"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var is_array_1 = require("./is-array");
var is_function_1 = require("./is-function");
function safeCallWithNull(func) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (!is_function_1.default(func)) {
        return null;
    }
    if (is_array_1.default(args[0])) {
        return func.call.apply(func, tslib_1.__spreadArrays([null], args[0]));
    }
    return func.call.apply(func, tslib_1.__spreadArrays([null], args));
}
exports.default = safeCallWithNull;
//# sourceMappingURL=safe-call-with-null.js.map